<template>
    <v-container grid-list-xl fluid>
        <v-layout wrap>
            <v-flex xs12>
                <h1>Recebimento de pacotes na R2PP</h1>
                <v-divider class=" mb-2" />
            </v-flex>
        </v-layout>

        <v-layout wrap v-if="step >= 1">
            <v-flex xs12>
                <div class="subtitle-1" v-if="item.code"><strong>Código:</strong> {{ item.code }}</div>
                <div class="subtitle-1" v-if="item.store"><strong>Loja:</strong> {{ item.store.name }}</div>
                <div class="subtitle-1" v-if="hasDriver"><strong>Motorista:</strong> {{ driverName }}</div>
            </v-flex>
        </v-layout>

        <v-layout wrap v-if="step == null">
            <ChecklistHistory type="receive" label="Últimos recebimentos" @reopen="reopen" />
            <StoreList labelNotFound="Não foi localizado nenhuma CD." labelSelect="Selecione abaixo o CD que você ira receber:" endpoint="checklists/receive/stores"
                @selected="start" />
        </v-layout>

        <v-layout wrap v-else-if="step == 1">

            <v-flex md6 offset-md3 xs12 v-if="externalDriver == false">
                <v-btn @click="externalDriver = true" color="warning" class="mt-12" width="100%"> <v-icon left>connect_without_contact</v-icon>Motorista tercerizado </v-btn>
            </v-flex>

            <v-flex md6 offset-md3 xs12 v-if="externalDriver == true">
                <v-text-field :label="$t('Nome do motorista')" v-model="item.driverExternal" :rules="[rules.required, rules.min(5)]" clearable
                    v-on:keyup.enter="selectExternalUser" />
                <v-btn @click="selectExternalUser" color="success" class="mt-12" width="100%"> <v-icon left>navigate_next</v-icon>Próximo</v-btn>
            </v-flex>
            <UserList endpoint="checklists/receive/users" @selected="selectUser" v-else />
        </v-layout>

        <v-layout wrap v-else-if="step == 2">
            <v-flex xs12>
                <v-form ref="formStep2" @submit.prevent="">
                    <v-text-field :label="$t('Digite o número de pedidos')" v-model="item.ordersNumber" :rules="[rules.required, rules.range(1, 1000)]" type=" number" clearable
                        v-on:keyup.enter="startBip" ref="ordersNumberField" />
                </v-form>
            </v-flex>
            <v-flex xs12>
                <v-btn color="success" :disabled="item.ordersNumber == null" @click="startBip" class="mx-auto" width="100%">
                    Iniciar Bipagem
                </v-btn>
            </v-flex>
        </v-layout>

        <v-layout wrap v-else-if="step == 3">
            <v-flex xs12 sm6 md6 class="pa-0 pb-4">
                <v-card :color="reachedGoal ? 'success' : 'grey'">
                    <v-card-text class="white--text">
                        <div class="headline mb-2">
                            <v-icon dark>luggage</v-icon>
                            {{ item.ordersNumber }}
                        </div>
                        Número de pedidos informado
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 sm6 md6 class="pa-0" v-if="item">
                <v-card :color="reachedGoal ? 'success' : 'primary'">
                    <v-card-text class="white--text">
                        <div class="headline mb-2">
                            <v-icon dark>receipt</v-icon>
                            {{ item.count }}
                        </div>
                        Número de pedidos bipados
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12>
                <v-btn @click="showQRCode = true" color="success" class="mt-12" width="100%"> <v-icon left>qr_code_scanner</v-icon>Bipar Pedido </v-btn>
            </v-flex>
            <v-flex xs12 mt-12>
                <v-btn color="error" @click="finishStep1" class="mx-auto" width="100%">Encerrar bipagem</v-btn>
            </v-flex>
        </v-layout>

        <v-layout wrap v-else-if="step == 4">
            <v-flex xs12>
                <v-text-field :label="$t('Digite o número do embarque (Romaneio)')" v-model="item.extraCode" v-on:keyup.enter="createChecklist" clearable ref="codeField" />
            </v-flex>
            <v-flex xs12>
                <v-btn color="success" @click="finishStep2" class="mx-auto" width="100%">Finalizar</v-btn>
            </v-flex>
        </v-layout>

        <BarCode :show="showQRCode" @close="showQRCode = false" manual @onRead="readedQRCode">
            <template slot="header">
                <v-switch v-model="makeNoteBig" inset :label="$t('Marcar item como volumoso')" dense class="mt-n1" />
                <v-alert dense class="white--text" color="black" prominent border="left" v-if="information && (information.success || information.warning || information.error)">
                    <h2 class="white--text text-subtitle-1 text-left"><strong>Última leitura:</strong></h2>
                    <h2 class="green--text my-2" v-if="information.success" v-html="information.success"></h2>
                    <h2 class="orange--text my-2" v-if="information.warning" v-html="information.warning"></h2>
                    <h2 class="red--text my-2" v-if="information.error" v-html="information.error"></h2>
                </v-alert>
            </template>
        </BarCode>
        <ConfirmModal confirmText="Confirmar" cancelText="Cancelar" ref="confirm" />

        <MessageDialog :options="messageDialogOption" @close="closeBeepFeedback">
            <template slot="afterMessage">
                <div class="white--text" v-if="codeBippedToCheck">{{ $t("Código lido:") }} {{ codeBippedToCheck }}</div>
            </template>
        </MessageDialog>

    </v-container>
</template>

<script>
import rules from "@/helpers/rules";

import MessageDialog from "@/components/core/MessageDialog";
import ConfirmModal from "@/components/core/ConfirmModal";
import BarCode from "@/components/core/BarCode";
import StoreList from "@/components/shared/StoreList";
import UserList from "@/components/shared/UserList";
import ChecklistHistory from "@/components/shared/ChecklistHistory";

const itemClean = {
    extraCode: null,
    ordersNumber: null,
    store: null,
    driver: null,
    driverExternal: null,
};

export default {
    components: { MessageDialog, ConfirmModal, BarCode, StoreList, UserList, ChecklistHistory },

    data() {
        return {
            rules,
            loaded: false,
            filterName: null,
            showQRCode: false,
            makeNoteBig: false,
            messageDialogOption: undefined,
            information: { success: null, warning: null, error: null },
            externalDriver: false,
            driverName: null,
            codeBippedToCheck: null,
            step: null,
            item: JSON.parse(JSON.stringify(itemClean)),
            finishResult: null,
        };
    },

    computed: {
        hasDriver() {
            return this.item.driver || this.item.driverExternal;
        },
        reachedGoal() {
            return this.item && this.item.count >= this.item.ordersNumber;
        },
        inGoal() {
            return this.item && this.item.count == this.item.ordersNumber;
        },
        packagesBipped() {
            return this.item.ordersChecked ? this.item.ordersChecked.length : 0;
        },
        ordersBipped() {
            let a = this.item.ordersChecked;
            let uniqueArray = a.filter(function (item, pos) {
                return a.indexOf(item) == pos;
            });
            return uniqueArray.length;
        },
    },

    methods: {
        reopen(result) {
            if (result) {
                this.item = result;
                this.step = 3;
            }
        },
        readedQRCode(QRCode) {
            this.codeBippedToCheck = QRCode;
            this.bip();
        },
        start(store) {
            this.finishResult = null;
            this.item = JSON.parse(JSON.stringify(itemClean));
            this.item.store = store;
            this.step = 1;
        },
        selectUser(user) {
            this.driverName = user.name;
            this.item.driver = user.id;
            this.step = 2;
            this.$nextTick(() => this.$refs.ordersNumberField.focus());
        },
        selectExternalUser() {
            if (this.item.driverExternal && this.item.driverExternal.length >= 5) {
                this.driverName = this.item.driverExternal;
                this.step = 2;
                this.$nextTick(() => this.$refs.ordersNumberField.focus());
            } else {
                this.$eventHub.$emit("msgError", this.$t("Digite o nome do motorista"));
            }
        },
        startBip() {
            if (this.$refs.formStep2.validate())
                this.$http
                    .post(`checklists/receive/create`, this.item)
                    .then((result) => {
                        if (result) {
                            this.item = result;
                            this.step = 3;
                        } else {
                            this.$eventHub.$emit("msgError", this.$t("Erro ao criar um romaneio"));
                        }
                    })
                    .catch((error) => {
                        this.$eventHub.$emit("msgError", error.message ? error.message : this.$t("Erro ao criar um romaneio"));
                    });
        },
        closeBeepFeedback() {
            if (this.inGoal) {
                this.$eventHub.$emit("msgSuccess", this.$t("Já foram bipados o número de pacotes informado."));
            }
            this.showQRCode = true;
        },
        async bip() {
            this.showQRCode = false;
            this.information = { success: null, warning: null, error: null };
            this.messageDialogOption = { msg: "Conferindo...", type: "info" };

            if (this.codeBippedToCheck == null) {
                this.messageDialogOption = { msg: "Código inválido.", type: "critical" };
            } else {
                await this.$http
                    .patch(`checklists/receive/bip/${this.item.code}`, { data: { store: this.item.store.id, ticket: this.codeBippedToCheck, makeNoteBig: this.makeNoteBig } })
                    .then((result) => {
                        if (result) {
                            this.information.success = `<strong>Código:</strong> ${this.codeBippedToCheck}`;
                            if (result.created) {
                                this.information.warning = `Coleta registrada.`;
                            }

                            if (result.region) {
                                if (result.region.store && result.region.store.id != this.item.store.id) {
                                    this.information.error = `<br>ALERTA: pacote deveria ser recebido em: '${result.region.store.name}'<br><br><br>Região: ${result.region.name}`;
                                } else {
                                    this.information.error = `Região: <strong>${result.region.name}</strong>`;
                                }
                            }

                            this.messageDialogOption = { msg: "Pedido localizado com sucesso.", type: "success" };
                            if (result.checklist) {
                                this.item = result.checklist;
                            }
                        } else {
                            this.messageDialogOption = { msg: "Pedido não localizado", type: "critical" };
                        }
                    })
                    .catch((error) => {
                        this.messageDialogOption = { msg: error.message ? error.message : this.$t("Erro ao localizar pedido"), type: "critical" };
                    });
            }
        },
        restartScreen() {
            this.loaded = false;
            this.showQRCode = false;
            this.codeBippedToCheck = null;
            this.step = null;
            this.item = JSON.parse(JSON.stringify(itemClean));
            this.finishResult = null;
        },
        updateOrder() {
            this.$http
                .patch(`checklists/receive/update/${this.item.code}`, { data: { extraCode: this.item.extraCode } })
                .then((result) => {
                    if (result) {
                        this.restartScreen();
                    } else {
                        this.$eventHub.$emit("msgError", this.$t("Erro ao atualizar dados do romaneio."));
                    }
                })
                .catch((error) => {
                    this.$eventHub.$emit("msgError", error.message ? error.message : this.$t("Erro ao atualizar dados do romaneio."));

                });
        },
        finishStep1() {
            this.$refs.confirm.open("", "Deseja mesmo encerrar o recebimento?").then((confirm) => {
                if (confirm) {
                    this.$http
                        .patch(`checklists/receive/finish/${this.item.code}`)
                        .then(() => {
                            // this.step = 4;
                            // this.$nextTick(() => this.$refs.codeField.focus());
                            this.restartScreen();
                        })
                        .catch((error) => {
                            this.$eventHub.$emit("msgError", error.message ? error.message : this.$t("Erro ao atualizar dados do romaneio."));
                        });
                }
            });
        },
        finishStep2() {
            if (this.item.extraCode) {
                this.updateOrder();
            } else {
                this.$refs.confirm.open("", "Deseja finalizar sem digitar o código do romaneio?").then((confirm) => {
                    if (confirm) {
                        this.restartScreen();
                    } else {
                        this.updateOrder();
                    }
                });
            }
        },
    },
};
</script>